/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentStats } from './DocumentStats';
import {
    DocumentStatsFromJSON,
    DocumentStatsFromJSONTyped,
    DocumentStatsToJSON,
    DocumentStatsToJSONTyped,
} from './DocumentStats';

/**
 * 
 * @export
 * @interface LeadDocumentStats
 */
export interface LeadDocumentStats {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    documents: Array<DocumentStats>;
}

/**
 * Check if a given object implements the LeadDocumentStats interface.
 */
export function instanceOfLeadDocumentStats(value: object): value is LeadDocumentStats {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function LeadDocumentStatsFromJSON(json: any): LeadDocumentStats {
    return LeadDocumentStatsFromJSONTyped(json, false);
}

export function LeadDocumentStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDocumentStats {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'documents': ((json['documents'] as Array<any>).map(DocumentStatsFromJSON)),
    };
}

export function LeadDocumentStatsToJSON(json: any): LeadDocumentStats {
    return LeadDocumentStatsToJSONTyped(json, false);
}

export function LeadDocumentStatsToJSONTyped(value?: LeadDocumentStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'documents': ((value['documents'] as Array<any>).map(DocumentStatsToJSON)),
    };
}

